module.exports = __webpack_public_path__ + "img/icons_24.d5de0ee6.png";